import SidebarCollapse from "@builder/components/app/SidebarCollapse";
import EditableInfo from "../../EditableInfo";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import SimpleCheckbox from "@builder/components/general/SimpleCheckbox";
import OliverText, { TextType } from "@builder/components/general/OliverText";
import "./style.scss";
import { useEffect, useMemo } from "react";
import { SmartTileNode } from "@common/build/types";
import { updateNodeProperty } from "@builder/store/slices/BuilderSlice/builderSlice";
import { EditableProps } from "../../editableProps";

const EditActionTile = ({ condition }: EditableProps) => {
    const dispatch = useAppDispatch();
    const selectedNode = useAppSelector(getSelectedNode) as SmartTileNode;
    const cvMode = useAppSelector(state => state.builder.conditionalVariationMode);
    const allowedActions = selectedNode.actionTileActions || [];
    const actions = useAppSelector(state => state.builder.build.actionBuilder);

    const actionOptions = useMemo(() => {
        return Object.values(actions || {}).reduce((acc: { value: string; name: string; checked: boolean }[], action) => {
            acc.push({
                value: action.id,
                name: action.name,
                checked: allowedActions?.includes(action.id) || false
            });
            return acc;
        }, []);
    }, [actions, allowedActions]);

    const handleActionChange = (value: string, checked: boolean) => {
        if (value === "*") {
            if (checked) {
                dispatch(updateNodeProperty({ propertyPath: ["actionTileActions"], value: ["*"] }));
            } else {
                dispatch(updateNodeProperty({ propertyPath: ["actionTileActions"], value: [] }));
            }
        } else {
            if (checked) {
                dispatch(updateNodeProperty({ propertyPath: ["actionTileActions"], value: [...allowedActions, value] }));
            } else {
                if (allowedActions?.[0] === "*") {
                    dispatch(
                        updateNodeProperty({
                            propertyPath: ["actionTileActions"],
                            value: actionOptions.map(action => action.value).filter(action => action !== value)
                        })
                    );
                } else {
                    dispatch(
                        updateNodeProperty({
                            propertyPath: ["actionTileActions"],
                            value: allowedActions.filter(action => action !== value)
                        })
                    );
                }
            }
        }
    };

    useEffect(() => {
        if (allowedActions && actionOptions) {
            if (allowedActions.length === actionOptions.length && allowedActions[0] !== "*") {
                dispatch(updateNodeProperty({ propertyPath: ["actionTileActions"], value: ["*"] }));
            }
        }
    }, [allowedActions, actionOptions]);

    if (condition && !condition(selectedNode, cvMode)) return null;

    return (
        <SidebarCollapse title="Setup">
            <div className="edit-action-tile">
                <EditableInfo header="actionTileInfo1" body="actionTileInfo2" />
                <div className="edit-action-tile-divider"></div>
                <div className="action-tile-inputs">
                    <OliverText type={TextType.BODY_4}>Assignable actions:</OliverText>
                    <SimpleCheckbox label="All actions" value="*" checked={allowedActions?.[0] === "*"} callback={handleActionChange} />
                    <div className="indented-inputs">
                        {actionOptions.map(action => (
                            <SimpleCheckbox
                                key={action.value}
                                label={action.name}
                                value={action.value}
                                checked={action.checked || allowedActions?.[0] === "*"}
                                callback={handleActionChange}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </SidebarCollapse>
    );
};

export default EditActionTile;
